import { render, staticRenderFns } from "./bills-detail.vue?vue&type=template&id=71af7562&scoped=true"
import script from "./bills-detail.vue?vue&type=script&lang=js"
export * from "./bills-detail.vue?vue&type=script&lang=js"
import style0 from "./bills-detail.vue?vue&type=style&index=0&id=71af7562&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af7562",
  null
  
)

export default component.exports